import ClientsDiversController from './clients.divers.controller';

export default {
    template: require('./clients.divers.tpl.html'),
    controller: ClientsDiversController
};
